import {clientSlice, formInfoSlice, workflowSlice, credentialSlice, brandfolderSlice} from './entities';

export const clientEntityActions = clientSlice.actions;
export const workflowEntityActions = workflowSlice.actions;
export const formInfoEntityActions = formInfoSlice.actions;
export const credentialEntityActions = credentialSlice.actions;
export const brandfolderEntityActions = brandfolderSlice.actions;
